<div class="inbox-datatable__main-content scrollable-component partial-integration">
	<form #filterForm>
		<div class="inbox-filter__content mb-1">
			<div class="filter">
				<cv-input 
					[label]="'Provider'" 
					[type]="'search'" 
					[placeholder]="'Provider'"
					[value]="filterLogs.provider" 
					(maxlength)="100"
					(textCleared)="onFiltersChange('Provider', $event)"
					(controlKeyup)="onFiltersChange('Provider', $event)">
				</cv-input>
			</div>
			<div class="filter">
				<cv-input 
					[label]="'Provider Id'" 
					[type]="'search'" 
					[placeholder]="'Provider Id'"
					[value]="filterLogs.providerId" 
					(maxlength)="100"
					(textCleared)="onFiltersChange('ProviderId', $event)"
					(controlKeyup)="onFiltersChange('ProviderId', $event)">
				</cv-input>
			</div>
			<div class="filter">
				<cv-input 
					[label]="'Loan Number'" 
					[type]="'search'"
					[placeholder]="'Loan Number'" 
					[value]="filterLogs.loanNumber"
					(maxlength)="100" 
					(textCleared)="onFiltersChange('LoanNumber', $event)"
					(controlKeyup)="onFiltersChange('LoanNumber', $event)">
				</cv-input>
			</div>
			<button class="btn btn-sm cv-btn-blue" (click)="onFiltersChange(null, $event)">
				<i class="fas fa-search"></i>
			</button>
		</div>
	</form>
	<div class="mb-3">
		<button class="btn-link btn btn-sm" (click)="clearAllFilters()">
			<i class="fa fa-trash mr-1"></i>
			clear filters
		</button>
	</div>
	<ag-grid-angular 
		#grid 
		class="ag-theme-balham configurable-grid" 
		[enableCellTextSelection]="true" 
		[style.height.px]="gridHeight"
		(gridReady)="onInitializeGrid($event)" 
		(gridSizeChanged)="resizeToFitColumns()"
		[pagination]="false" 
		[suppressPaginationPanel]="true" 
		[gridOptions]="gridOptions" 
		[domLayout]="'normal'"
		[rowData]="gridData">
	</ag-grid-angular>
	<div class="filter-input text-right limit">
		<cv-input 
			[displayMode]="'inline'" 
			[label]="'Limit'" 
			[placeholder]="'Limit'" 
			[type]="'number'"
			[value]="filterLogs.limit" 
			(maxlength)="2" 
			(controlChange)="onFiltersChange('limit', $event)"
			(controlKeyup)="onFiltersChange('limit', $event)">
		</cv-input>
	</div>
</div>
